export default class Anchor {
  static selector = "a";

  constructor(block) {
    this.block = block;

    this.block.addEventListener("click", this.handleClick);
    this.block.addEventListener("keydown", this.handleKeydown);
  }

  isMailTo = () => this.block.href.startsWith("mailto:");
  isTel = () => this.block.href.startsWith("tel:");
  isTargetBlank = () =>
    !!this.block.target && this.block.target.toLowerCase() === "_blank";
  isHardLink = () => this.block.hasAttribute("data-hard-link");
  isLocalUrl = () => this.block.host === window.location.host;
  isAdminUrl = () =>
    this.block.pathname.startsWith("/wp-admin") ||
    this.block.pathname.startsWith("/wp-login.php");
  isInAdminView = () =>
    window.location.pathname.startsWith("/wp-admin") ||
    window.location.pathname.startsWith("/wp-login.php");
  isSamePage = () => this.block.pathname === window.location.pathname && this.block.search === window.location.search;

  handleClick = (e) => {
    // short-circuit when:
    //  - we hare in wp-admin
    //  - is a target blank link
    //  - is an explicit hard-link
    //  - id not a local url
    //  - is an admin url
    //  - is mailto
    //  - is tel
    if (
      this.isInAdminView() ||
      this.isTargetBlank() ||
      this.isHardLink() ||
      !this.isLocalUrl() ||
      this.isAdminUrl() ||
      this.isMailTo() ||
      this.isTel()
    ) {
      return;
    }

    e.preventDefault();

    // if is link to current page
    if (this.isSamePage()) {
      return;
    }

    window.App.navigateTo(this.block.href);
  };
  handleKeydown = (e) => {
    if (e.which !== 13) {
      return;
    }

    if (!this.isLocalUrl() || this.isAdminUrl()) {
      return;
    }

    e.preventDefault();

    window.App.navigateTo(this.block.href);
  };

  onDestroy = () => {
    this.block.removeEventListener("click", this.handleClick);
    this.block.removeEventListener("keydown", this.handleKeydown);
  };
}
